"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var actions = __importStar(require("./actions"));
var authActions = __importStar(require("@app/features/auth/state/actions"));
var initialState = {};
var dashboardReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (typesafe_actions_1.getType(actions.refreshPackageCacheSuccess)):
            return __assign(__assign({}, state), { numPackageRefreshes: (state.numPackageRefreshes !== undefined) ? state.numPackageRefreshes + 1 : 0, packageCacheLastRefresh: action.payload });
        case (typesafe_actions_1.getType(authActions.setAsperaPluginTransferLimit)):
            return __assign(__assign({}, state), { asperaPluginTransferLimit: action.payload[0], blastPackageExpirationDays: action.payload[1] });
        case (typesafe_actions_1.getType(actions.updatedPackageCache)):
            return __assign(__assign({}, state), { latestNumUpdatedPackages: action.payload });
        default:
            return state;
    }
};
exports.dashboardReducer = dashboardReducer;
